import { render, staticRenderFns } from "./DragClue.vue?vue&type=template&id=37f620f0&scoped=true&"
import script from "./DragClue.vue?vue&type=script&lang=js&"
export * from "./DragClue.vue?vue&type=script&lang=js&"
import style0 from "./DragClue.vue?vue&type=style&index=0&id=37f620f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f620f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB03-CV-02\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37f620f0')) {
      api.createRecord('37f620f0', component.options)
    } else {
      api.reload('37f620f0', component.options)
    }
    module.hot.accept("./DragClue.vue?vue&type=template&id=37f620f0&scoped=true&", function () {
      api.rerender('37f620f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/Table/DragClue.vue"
export default component.exports